import React from "react";
import { useTinyHost } from "@tiny/host-contract";
import { SegmentIdentityView1 } from "@tiny/api";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import useCustomSegmentFeatures from "../../hooks/useCustomSegmentFeatures";
import { useRefresh } from "@tiny/components/src/RefreshProvider";

export function useAddAudienceButton() {
  const { showUpgradePopup, hasRightsToAccess } = useCustomSegmentFeatures();

  const { navigate } = useTinyHost();
  const { refresh } = useRefresh();
  const { mdUp } = useBreakpoints();

  const [audienceDialogOpen, setAudienceDialogOpen] = React.useState(false);

  const [addAudienceDialogOpen, setAddAudienceDialogOpen] =
    React.useState(false);

  const [addSegmentDialogOpen, setAddSegmentDialogOpen] = React.useState(false);

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const gotoAudienceDetails = React.useCallback(
    async (segment: SegmentIdentityView1) => {
      navigate.to(`/main/audience/sources/${segment.id}`);
    },
    [navigate]
  );

  const addIntegration = React.useCallback(() => {
    navigate.to("/main/integrations");
  }, [navigate]);

  const openAudienceDialog = React.useCallback(() => {
    setAudienceDialogOpen(true);
  }, []);

  const closeAudienceDialog = React.useCallback(() => {
    setAudienceDialogOpen(false);
  }, []);

  const openAddAudienceDialog = React.useCallback(() => {
    setAddAudienceDialogOpen(true);
  }, []);

  const closeAddAudienceDialog = React.useCallback(() => {
    setAddAudienceDialogOpen(false);
  }, []);

  const openAddSegmentDialog = React.useCallback(() => {
    setAddSegmentDialogOpen(true);
  }, []);

  const onAddSegment = React.useCallback(() => {
    if (hasRightsToAccess(true)) {
      openAddSegmentDialog();
    } else {
      showUpgradePopup();
    }
  }, [hasRightsToAccess, openAddSegmentDialog, showUpgradePopup]);

  const closeAddSegmentDialog = React.useCallback(() => {
    setAddSegmentDialogOpen(false);
  }, []);

  const openMobile = React.useCallback(() => {
    setMobileOpen(true);
  }, []);

  const closeMobile = React.useCallback(() => {
    setMobileOpen(false);
  }, []);

  const refetchAudience = React.useCallback(() => {
    refresh();
  }, []);

  return {
    addIntegration,
    audienceDialogOpen,
    openAudienceDialog,
    closeAudienceDialog,
    openAddAudienceDialog,
    closeAddAudienceDialog,
    addAudienceDialogOpen,
    gotoAudienceDetails,
    mdUp,
    mobileOpen,
    openMobile,
    closeMobile,
    addSegmentDialogOpen,
    openAddSegmentDialog,
    closeAddSegmentDialog,
    onAddSegment,
    refetchAudience,
  };
}
